import React from 'react';

const Dots = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <path d="M20.4 37.5c-6.9 0-12.6 5.6-12.6 12.6s5.6 12.6 12.6 12.6c6.9 0 12.6-5.6 12.6-12.6s-5.7-12.6-12.6-12.6zM50 37.5c-6.9 0-12.6 5.6-12.6 12.6S43.1 62.7 50 62.7c6.9 0 12.6-5.6 12.6-12.6S56.9 37.5 50 37.5zM79.6 37.5c-6.9 0-12.6 5.6-12.6 12.6s5.6 12.6 12.6 12.6c6.9 0 12.6-5.6 12.6-12.6s-5.6-12.6-12.6-12.6z" />
  </svg>
);

export default Dots;
